import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, Grid, Tabs, Tab, CircularProgress } from '@material-ui/core';

import { FormattedMessage, injectIntl } from 'react-intl';

import Address from './components/Address';
import Contact from './components/Contact';
import MainData from './components/MainData';
import AdditionalData from './components/AdditionalData';
import Documentation from '../../../Documentation';
import { useSelector, useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import { setCity } from 'app/store/slices/forms';
import { FormServiceContext } from 'app/utils/contexts';

import styles from './styles';
import notification from 'app/config/notification';
import AlertMessage from 'app/components/AlertMessage';
import SaveButton from 'app/components/SaveButton';
import FinalizeButton from 'app/components/FinalizeButton';
const useStyles = makeStyles(styles);

function Company(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isHeadquarters, setIsHeadquarters] = useState(true);

  const {
    initialValues,
    validationSchema,
    validateForm,
    validateOnSave,
    loadingDocuments,
    onSubmit,
    onSave,
    onCancel,
    mainColor,
    hideActionBtn,
    hideFinalizeBtn,
    isInternalForm,
    canEdit,
  } = useContext(FormServiceContext);

  const viewsMaindata = 0;
  const viewsContact = 1;
  const viewsAddress = 2;
  const viewsAditionaldata = 3;
  const viewsDocumentationregs = 4;

  const city = useSelector(state => state.forms.city);
  const service = useSelector(state => state.services.details);

  const [view, setView] = useState(viewsMaindata);
  const [changingDate, setChangingDate] = useState(0);

  useEffect(() => {
    const init = async () => {
      const temp = { ...city };
      if (initialValues.enderecoMatriz?.municipio) {
        temp.cityPrincipal = initialValues.enderecoMatriz?.municipio;
      }
      if (initialValues.enderecoFilial?.municipio) {
        temp.citySecondary = initialValues.enderecoFilial?.municipio;
      }
      dispatch(setCity(temp));
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service]);

  const onChangeDate = (values, field, value) => {
    setChangingDate(changingDate + 1);
    values[field] = value;
  };

  const handleViewChange = (event, value) => {
    setView(value);
  };

  const renderTabs = () => {
    return (
      <Grid container spacing={3} className={classes.tabsContainer}>
        <Tabs
          variant="scrollable"
          onChange={handleViewChange}
          className={classes.tabs}
          indicatorColor={mainColor ? mainColor : 'primary'}
          textColor={mainColor ? mainColor : 'primary'}
          value={view}
        >
          <Tab className={classes.tab} label={<FormattedMessage id="LABELS.COMMONS.MAIN_DATA" />} />
          <Tab className={classes.tab} label={<FormattedMessage id="LABELS.COMMONS.CONTACT" />} />
          <Tab className={classes.tab} label={<FormattedMessage id="LABELS.COMMONS.ADDRESS" />} />
          <Tab
            className={classes.tab}
            label={<FormattedMessage id="LABELS.COMMONS.ADITIONAL_DATA" />}
          />
          {loadingDocuments && !isInternalForm && (
            <Tab
              className={classes.tab}
              label={<CircularProgress size={12} className={classes.loading} />}
            />
          )}
          {!isInternalForm && !loadingDocuments && (
            <Tab
              className={classes.tab}
              label={<FormattedMessage id="LABELS.COMMONS.DOCUMENTATION" />}
            />
          )}
        </Tabs>
      </Grid>
    );
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues ? initialValues : {}}
        validationSchema={validationSchema}
        // validateOnBlur={false}
        // validateOnChange={false}
        onSubmit={values => {
          onSubmit(values);
        }}
      >
        {props => {
          return (
            <Form className={classes.containerForm}>
              {renderTabs()}

              <AlertMessage isInternalForm={isInternalForm} />

              {view === viewsMaindata && (
                <MainData
                  {...props}
                  onChangeDate={onChangeDate}
                  isHeadquarters={isHeadquarters}
                  setIsHeadquarters={setIsHeadquarters}
                />
              )}
              {view === viewsContact && <Contact {...props} />}
              {view === viewsAddress && (
                <Address
                  {...props}
                  isHeadquarters={isHeadquarters}
                  setIsHeadquarters={setIsHeadquarters}
                />
              )}
              {view === viewsAditionaldata && (
                <AdditionalData {...props} onChangeDate={onChangeDate} />
              )}
              {view === viewsDocumentationregs && <Documentation {...props} />}

              <SaveButton
                mainColor={mainColor}
                hideActionBtn={hideActionBtn}
                isInternalForm={isInternalForm}
                canEdit={canEdit}
                onCancel={() => onCancel(props.values)}
                onSave={() => {
                  if (validateOnSave) {
                    props.validateForm().then(res => {
                      if (Object.keys(res).length <= 0) onSave(props.values);
                      else {
                        notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                          toastId: 'VALIDATION',
                          type: 'error',
                        });
                      }
                    });
                  } else {
                    onSave(props.values);
                  }
                }}
              />

              <FinalizeButton
                mainColor={mainColor}
                hideFinalizeBtn={hideFinalizeBtn}
                isInternalForm={isInternalForm}
                canEdit={canEdit}
                onSubmit={() => {
                  validateForm && validateForm(props.validateForm());
                }}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default injectIntl(Company);
